/*
* @描述: 订单商品配置页面
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-02-12 10:59:24
*/
<template>
    <van-popup v-if="dialogVisible"
               position="bottom"
               v-model.sync="dialogVisible"
               round
               :style="{ width: '100%'}">
        <div class="popup_title_wrap">
            <span class="popup_title">选择产品配置</span>
            <van-icon name="cross" @click="handleClickProductConfigCancel"/>
        </div>
        <div class="product_detail_wrap" v-loading="loading">
            <div class="product_image_wrap">
                <el-carousel :autoplay="false"
                             :interval="5000"
                             indicator-position="none"
                             :arrow="productDetail.image&&productDetail.image.length>1?'hover':'never'">
                    <el-carousel-item v-for="item in productDetail.image" :key="item">
                        <img :src="item" alt="">
                    </el-carousel-item>
                </el-carousel>
                <div>
                    <span class="goods_name" v-text="productDetail.goods_name"></span>
                    <el-tag v-if="productDetail.brand_info"
                            size="mini"
                            type="warning"
                            v-text="productDetail.brand_info.name"></el-tag>
                </div>
            </div>
            <div v-if="productDetail.description"
                 v-text="productDetail.description"
                 class="goods_description_wrap">
            </div>
            <div class="product_config_wrap">
                <div v-if="source==='order'">
                    <div v-if="productDetail.goods_type==='basic'">
                        <div class="page_little_title">
                            <span class="title">选择配置</span>
                        </div>
                        <ul class="goods_spec_list">
                            <li v-for="item in productDetail.goods_specs"
                                :key="item.goods_spec_id"
                                class="goods_spec_item">
                                <div class="goods_spec_name" v-text="item.name"></div>
                                <ul class="goods_spec_values">
                                    <li v-for="spec in item.goods_spec_values"
                                        :key="spec.product_spec_value_id"
                                        :class="{'active':item.active_sku_id === spec.product_spec_value_id,'is_disabled':spec.disabled}"
                                        class="goods_spec_value"
                                        @click="handleClickProductSpecValue(item,spec)"
                                        v-text="spec.value"></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div v-else-if="productDetail.goods_type==='bundle'">
                        <div class="page_little_title">
                            <span class="title">组合产品</span>
                        </div>
                        <ul class="goods_parts_list">
                            <li v-for="(goods_part,index) in productDetail.goods_parts"
                                :key="index"
                                class="goods_parts_item">
                                <div class="flex_js_wrap part_name_wrap">
                                    <div class="part_name" v-text="goods_part.part_name"></div>
                                    <span class="handle_icon_wrap handle_icon_danger_wrap"
                                          @click="handleClickDeleteGoodsPart(goods_part,index)">
                                        <i class="iconfont icon-shanchu1"></i>
                                    </span>
                                </div>
                                <div class="goods_spec_wrap">
                                    <ul v-if="goods_part.goods_type==='basic'" class="goods_spec_list">
                                        <li v-for="part_item in goods_part.goods_part_items"
                                            :key="part_item.goods_part_item_id"
                                            class="goods_spec_item">
                                            <ul>
                                                <li v-for="spec in part_item.goods_specs" :key="spec.product_spec_id"
                                                    class="part_spec_item">
                                                    <div class="spec_name" v-text="spec.name"></div>
                                                    <ul class="goods_spec_values">
                                                        <li v-for="item in spec.goods_spec_values"
                                                            class="goods_spec_value"
                                                            :class="{'active':spec.active_sku_id===item.product_spec_value_id,'is_disabled':item.disabled}"
                                                            @click="handleClickBasicGoodsPartItem(goods_part,part_item,spec,item)"
                                                            v-text="item.value"></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <ul v-else class="goods_spec_values">
                                        <li v-for="item in goods_part.goods_part_items"
                                            :key="item.goods_part_item_id"
                                            class="goods_spec_value"
                                            :class="{'active':goods_part.active_sku_id === item.goods_part_item_id}"
                                            @click="handleClickOtherGoodsPartItem(goods_part,item)"
                                            v-text="item.goods_name"></li>
                                    </ul>
                                </div>
                                <div class="flex_js_wrap part_num_wrap" v-if="source==='order'">
                                    <span>数量：</span>
                                    <el-input-number v-model="goods_part.num"
                                                     :disabled="goods_part.num_edit===0"
                                                     :min="1"
                                                     size="mini"
                                                     @change="handleGoodsPartNumChange">
                                    </el-input-number>
                                </div>
                            </li>
                        </ul>
                        <div v-if="bundleGoodsOtherConfig.length"
                             @click="otherConfigVisible=true"
                             class="add_other_config_btn">
                            <i class="el-icon-plus"></i>
                            <span>添加配置</span>
                        </div>
                    </div>
                    <div class="page_little_title">
                        <span class="title">填写订单信息</span>
                    </div>
                    <van-form ref="productDetailForm"
                              input-align="right">
                        <van-field label="销售/租借：">
                            <template #input>
                                <el-radio-group v-model="productDetailForm.type"
                                                :disabled="is_release===1"
                                                @change="handleProductTypeChange">
                                    <el-radio :disabled="productDetailForm.is_sale===0" :label="1">销售</el-radio>
                                    <el-radio :disabled="productDetailForm.is_lease===0" :label="2">租借</el-radio>
                                </el-radio-group>
                            </template>
                        </van-field>
                        <div v-if="productDetailForm.can_in_out_stock===1&&productDetailForm.type===2">
                            <van-field label="租借开始时间："
                                       readonly
                                       is-link
                                       name="start_at"
                                       required
                                       placeholder="请选择租借开始时间"
                                       :rules="productDetailFormRules.start_at"
                                       :value="productDetailForm.start_at"></van-field>
                            <van-field label="租借结束时间："
                                       readonly
                                       is-link
                                       name="end_at"
                                       required
                                       placeholder="请选择租借结束时间"
                                       :rules="productDetailFormRules.end_at"
                                       :value="productDetailForm.end_at"></van-field>
                        </div>
                        <van-field label="成本："
                                   readonly
                                   :value="productDetailForm.cost_price?'¥' + productDetailForm.cost_price:'¥0.00'"></van-field>
                        <van-field :label="productDetailForm.type===1?'销售指导单价：':'租借指导单价：'"
                                   readonly
                                   :value="productDetailForm.guide_price?'¥' + productDetailForm.guide_price:'¥0.00'">
                        </van-field>
                        <van-field label="数量："
                                   v-model="productDetailForm.num"
                                   placeholder="请输入数量"
                                   type="number"
                                   @blur="handleProductNumChange">
                        </van-field>
                        <van-field label="单价："
                                   v-model="productDetailForm.price.value"
                                   placeholder="请输入单价"
                                   @blur="handleProductPriceChange">
                        </van-field>
                        <van-field label="总价："
                                   readonly
                                   :value="productDetailForm.subtotal_price.text?'¥'+productDetailForm.subtotal_price.text:'¥0.00'"
                                   placeholder="请输入单价">
                        </van-field>
                    </van-form>
                </div>
            </div>
            <div class="product_config_btn_wrap">
                <el-button size="small" plain type="primary" @click="handleClickProductConfigSubmit(false)">添加至已选
                </el-button>
                <el-button :disabled="loading" size="small" type="primary"
                           @click="handleClickProductConfigSubmit(true)">立即提交
                </el-button>
            </div>
        </div>
        <!--单选弹窗-->
        <van-overlay :custom-style="{background: 'rgba(0, 0, 0, 0.3)'}"
                     v-if="otherConfigVisible"
                     :show="otherConfigVisible">
            <div class="other_config_wrap">
                <ul class="other_config_list">
                    <li v-for="(item,index) in bundleGoodsOtherConfig"
                        :key="item.goods_part_id"
                        class="other_config_item"
                        @click="handleClickAddOtherConfig(item,index)"
                        v-text="item.part_name"></li>
                </ul>
                <div class="cancel_btn" @click="otherConfigVisible=false">取消</div>
            </div>
        </van-overlay>
    </van-popup>
</template>
<script>
import {orderBundleGoodsDetail, orderGoodsDetail} from "@/api";

export default {
    name: "ProductConfigDialog",
    data() {
        return {
            productDetail: {},
            productDetailForm: {
                type: 0,
                num: 1,
                price: {
                    value: '',
                    text: '',
                    currency: 'CNY',
                    value_converted: ''
                },
                cost_price: '',
                guide_price: '',
                sale_guide_price: '',
                lease_guide_price: '',
                subtotal_price: {
                    value: 0,
                    text: '',
                    currency: 'CNY',
                    value_converted: ''
                },
                start_at: null,
                end_at: null,
                sku_key: '',
                goods_sku_name: '',
                goods_name: '',
                can_in_out_stock: 0,
            },
            productDetailFormRules: {
                start_at: [{
                    required: true,
                    trigger: 'onChange',
                    message: '请选择租借开始时间',
                }],
                end_at: [{
                    required: true,
                    trigger: 'onChange',
                    message: '请选择租借结束时间',
                }],
            },
            loading: false,
            bundleGoodsOtherConfig: [],
            otherConfigVisible: false,
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        product_type: {
            type: String,
            default: ''
        },
        goods_id: {
            type: Number,
            default: 0
        },
        goods_detail: {
            type: Object,
            default: () => {
                return {}
            }
        },
        source: {
            type: String,
            default: 'order'
        },
        is_release: {
            type: Number,
            default: 0
        }
    },
    created() {
        this.getProductConfigDetail()
    },
    mounted() {
    },
    methods: {
        //产品获取配置
        getProductConfigDetail() {
            this.loading = true
            if (this.product_type === 'bundle') {
                orderBundleGoodsDetail({
                    id: this.goods_id
                }).then(res => {
                    if (res.code === 200) {
                        this.productDetail = res.data
                        const goods_parts = res.data.goods_parts
                        this.productDetail.goods_parts = goods_parts.filter(goods => goods.is_show === 1)
                        this.productDetail.image = res.data.image && res.data.image.length ? res.data.image : ['https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg']
                        this.bundleGoodsOtherConfig = JSON.parse(JSON.stringify(goods_parts.filter(goods => goods.is_show === 0 || goods.is_add === 1)))
                        this.productDetailForm.goods_type = res.data.goods_type
                        this.productDetailForm.is_sale = res.data.is_sale
                        this.productDetailForm.is_lease = res.data.is_lease
                        if (Object.keys(this.goods_detail).length === 0) {
                            if (this.productDetailForm.is_sale === 1) {
                                this.productDetailForm.type = 1
                            } else {
                                if (this.productDetailForm.is_lease === 1) {
                                    this.productDetailForm.type = 2
                                }
                            }
                        } else {
                            this.productDetailForm.type = this.goods_detail.type
                            this.productDetailForm.order_goods_id = this.goods_detail.order_goods_id
                            this.productDetailForm.can_in_out_stock = this.goods_detail.is_virtual
                            this.productDetailForm.cost_price = this.goods_detail.cost_price
                            this.productDetailForm.guide_price = this.goods_detail.guide_price
                            this.productDetailForm.sale_guide_price = this.goods_detail.sale_guide_price
                            this.productDetailForm.lease_guide_price = this.goods_detail.lease_guide_price
                            this.productDetailForm.is_lease = this.goods_detail.is_lease
                            this.productDetailForm.is_sale = this.goods_detail.is_sale
                            this.productDetailForm.num = this.goods_detail.num
                            this.productDetailForm.price = this.goods_detail.price
                            this.productDetailForm.subtotal_price = this.goods_detail.subtotal_price
                            if (this.productDetailForm.type === 2) {
                                this.productDetailForm.start_at = this.goods_detail.start_at
                                this.productDetailForm.end_at = this.goods_detail.end_at
                            }
                            if (this.goods_detail._child.length) {
                                let goodData = JSON.parse(JSON.stringify(this.productDetail.goods_parts))
                                this.productDetail.goods_parts = []
                                this.goods_detail._child.forEach(old_order_part => {
                                    let goods_part = goodData.find(item => item.goods_part_id === old_order_part.part_id)
                                    if (goods_part) {
                                        if (old_order_part.order_goods_id) {
                                            goods_part.order_goods_id = old_order_part.order_goods_id
                                        }
                                        goods_part = JSON.parse(JSON.stringify(goods_part))
                                        goods_part.num = old_order_part.num
                                        goods_part.goods_part_items.forEach(part_item => {
                                            const active_item = part_item.goods_skus.find(item => item.goods_sku_id === old_order_part.goods_sku_id)
                                            if (active_item) {
                                                this.$set(goods_part, 'active_sku', active_item)
                                                if (part_item.goods_type === 'basic') {
                                                    goods_part.active_sku_id = goods_part.active_sku.sku_id
                                                    const sku_key = active_item.sku_key.split(',').map(item => Number(item))
                                                    part_item.goods_specs.forEach(spec => {
                                                        spec.goods_spec_values.forEach(item => {
                                                            if (sku_key.indexOf(item.product_spec_value_id) > -1) {
                                                                this.$set(spec, 'active_sku_id', item.product_spec_value_id)
                                                            }
                                                        })
                                                    })
                                                } else {
                                                    this.$set(goods_part, 'active_sku_id', goods_part.active_sku.goods_part_item_id)
                                                }
                                            }
                                        })
                                        this.productDetail.goods_parts.push(goods_part)
                                    }
                                })
                                goodData.forEach(part_item => {
                                    if (!this.goods_detail._child.find(item => item.part_id === part_item.goods_part_id)) {
                                        this.productDetail.goods_parts.push(part_item)
                                    }
                                })
                            }
                        }
                    }
                    this.loading = false
                })
            } else {
                orderGoodsDetail({
                    id: this.goods_id
                }).then(res => {
                    if (res.code === 200) {
                        this.productDetail = res.data
                        this.productDetailForm.goods_type = res.data.goods_type
                        this.productDetailForm.order_goods_id = this.goods_detail.order_goods_id
                        if (res.data.image && res.data.image.length) {
                            this.productDetail.image = res.data.image
                            this.productDetail.old_image = res.data.image
                        } else {
                            this.productDetail.image = ['https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg']
                        }
                        if (res.data.goods_skus && res.data.goods_skus.length) {
                            if (this.productDetailForm.goods_type !== 'basic') {
                                const first_sku = res.data.goods_skus[0]
                                for (let goodsSkusKey in first_sku) {
                                    this.$set(this.productDetailForm, goodsSkusKey, first_sku[goodsSkusKey])
                                }
                                this.productDetailForm.goods_name = this.productDetail.goods_name
                                if (Object.keys(this.goods_detail).length === 0) {
                                    if (this.productDetailForm.is_sale === 1) {
                                        this.productDetailForm.type = 1
                                        this.productDetailForm.guide_price = this.productDetailForm.sale_price
                                        this.productDetailForm.price.value = this.productDetailForm.sale_price
                                        this.productDetailForm.price.text = this.productDetailForm.sale_price
                                    } else {
                                        if (this.productDetailForm.is_lease === 1) {
                                            this.productDetailForm.type = 2
                                            this.productDetailForm.guide_price = this.productDetailForm.lease_price
                                            this.productDetailForm.price.value = this.productDetailForm.lease_price
                                            this.productDetailForm.price.text = this.productDetailForm.lease_price
                                        }
                                    }
                                    this.productDetailForm.sale_guide_price = this.productDetailForm.sale_price
                                    this.productDetailForm.lease_guide_price = this.productDetailForm.lease_price
                                    this.productDetailForm.price.value_converted = this.productDetailForm.price.value
                                    const subtotal_price = this.productDetailForm.price.value * this.productDetailForm.num
                                    this.productDetailForm.subtotal_price.value = Number(subtotal_price.toFixed(2))
                                    this.productDetailForm.subtotal_price.text = this.productDetailForm.subtotal_price.value.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })
                                    this.productDetailForm.subtotal_price.value_converted = this.productDetailForm.subtotal_price.value
                                } else {
                                    this.productDetailForm.type = this.goods_detail.type
                                    this.productDetailForm.guide_price = this.goods_detail.guide_price
                                    if (this.productDetailForm.type === 2) {
                                        this.productDetailForm.start_at = this.goods_detail.start_at
                                        this.productDetailForm.end_at = this.goods_detail.end_at
                                    }
                                    this.productDetailForm.sale_guide_price = this.goods_detail.sale_guide_price
                                    this.productDetailForm.lease_guide_price = this.goods_detail.lease_guide_price
                                    this.productDetailForm.price = this.goods_detail.price
                                    this.productDetailForm.num = this.goods_detail.num
                                    this.productDetailForm.subtotal_price = this.goods_detail.subtotal_price
                                }
                            } else {
                                if (Object.keys(this.goods_detail).length > 0) {
                                    this.productDetailForm.type = this.goods_detail.type
                                    this.productDetailForm.sale_guide_price = this.goods_detail.sale_guide_price
                                    this.productDetailForm.lease_guide_price = this.goods_detail.lease_guide_price
                                    this.productDetailForm.guide_price = this.goods_detail.guide_price
                                    this.productDetailForm.num = this.goods_detail.num
                                    this.productDetailForm.price = this.goods_detail.price
                                    this.productDetailForm.subtotal_price = this.goods_detail.subtotal_price
                                    const active_goods_skus = this.productDetail.goods_skus.find(sku => sku.goods_sku_id === this.goods_detail.goods_sku_id)
                                    if (active_goods_skus) {
                                        for (let goodsSkusKey in active_goods_skus) {
                                            this.$set(this.productDetailForm, goodsSkusKey, active_goods_skus[goodsSkusKey])
                                        }
                                        this.productDetailForm.goods_sku_name = active_goods_skus.goods_name
                                        if (active_goods_skus.image) {
                                            this.productDetail.image = [active_goods_skus.image]
                                        }
                                        if (this.productDetailForm.type === 1 && this.productDetailForm.is_sale === 1) {
                                            this.productDetailForm.guide_price = active_goods_skus.sale_price
                                        }
                                        if (this.productDetailForm.type === 2 && this.productDetailForm.is_lease === 1) {
                                            this.productDetailForm.guide_price = active_goods_skus.lease_price
                                        }
                                        const skuKeysSet = new Set(active_goods_skus.sku_key.split(',').map(item => {
                                            const num = Number(item.trim());
                                            return Number.isInteger(num) ? num : null;
                                        }).filter(num => num !== null));
                                        this.productDetail.goods_specs.forEach(goods_spec => {
                                            goods_spec.goods_spec_values.forEach(goods_spec_value => {
                                                if (skuKeysSet.has(goods_spec_value.product_spec_value_id)) {
                                                    this.$set(goods_spec, 'active_sku_id', goods_spec_value.product_spec_value_id);
                                                }
                                            });
                                        })
                                    }
                                }
                            }
                        }
                    }
                    this.loading = false
                })
            }
        },

        //商品类型切换事件
        handleProductTypeChange(val) {
            if (val === 1) {
                if (this.product_type === 'bundle') {
                    this.computedBundleGoodsPrice()
                } else {
                    this.productDetailForm.guide_price = this.productDetailForm.sale_price
                    this.productDetailForm.start_at = null
                    this.productDetailForm.end_at = null
                }
            } else {
                if (this.product_type === 'bundle') {
                    this.computedBundleGoodsPrice()
                } else {
                    this.productDetailForm.guide_price = this.productDetailForm.lease_price
                }
            }
            if (this.product_type === 'bundle') {
                this.productDetail.goods_parts.forEach(goods_part => {
                    goods_part.type = val
                })
            }
        },

        //商品数量变化事件
        handleProductNumChange() {
            if (Object.keys(this.goods_detail).length && this.goods_detail.return_num && this.goods_detail.return_num > 0 && this.productDetailForm.num < this.goods_detail.return_num) {
                this.$set(this.productDetailForm, 'num', this.goods_detail.return_num)
                return this.$toast.fail(`当前产品有${this.goods_detail.return_num}个已归还，无法减少`)
            }
            const subtotal_price = this.productDetailForm.price.value * this.productDetailForm.num
            this.productDetailForm.subtotal_price.value = Number(subtotal_price.toFixed(2))
            this.productDetailForm.subtotal_price.text = this.productDetailForm.subtotal_price.value.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
            this.productDetailForm.subtotal_price.value_converted = this.productDetailForm.subtotal_price.value
        },

        //商品单价变化事件
        handleProductPriceChange() {
            let value = this.productDetailForm.price.value.replace(/[^\d.]/g, '')
            this.$set(this.productDetailForm.price, 'value', Number(value).toFixed(2))
            this.$set(this.productDetailForm.price, 'text', Number(value).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }))
            this.productDetailForm.price.value_converted = this.productDetailForm.price.value
            const subtotal_price = this.productDetailForm.price.value * this.productDetailForm.num
            this.productDetailForm.subtotal_price.value = Number(subtotal_price.toFixed(2))
            this.productDetailForm.subtotal_price.text = this.productDetailForm.subtotal_price.value.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
            this.productDetailForm.subtotal_price.value_converted = this.productDetailForm.subtotal_price.value
        },

        //点击选择标准产品配置
        handleClickProductSpecValue(item, spec) {
            if (item.active_sku_id === spec.product_spec_value_id) return false
            if (spec.disabled) return false
            this.$set(item, 'active_sku_id', spec.product_spec_value_id)
            let arr = [];
            if (this.productDetail.goods_skus.length > 0) {
                arr = this.getProductConfig(this.productDetail.goods_skus, Number(item.active_sku_id))
            }
            this.productDetail.goods_specs.forEach(spec_item => {
                spec_item.goods_spec_values.forEach(spec_value => {
                    this.$set(spec_value, 'disabled', false)
                    if (arr.indexOf(spec_value.product_spec_value_id) < 0 && spec_value.product_spec_id !== spec.product_spec_id) {
                        this.$set(spec_value, 'disabled', true)
                        if (spec_value.product_spec_value_id === spec_item.active_sku_id) {
                            this.$set(spec_item, 'active_sku_id', 0)
                        }
                    }
                })
            })
            const active_sku = this.productDetail.goods_skus.find(sku => sku.sku_key === this.productDetail.goods_specs.map(goods => goods.active_sku_id).join())
            if (active_sku) {
                if (active_sku.image) {
                    this.productDetail.image = [active_sku.image]
                } else {
                    this.productDetail.image = this.productDetail.old_image ? this.productDetail.old_image : ['https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg']
                }
                for (let goodsSkusKey in active_sku) {
                    this.$set(this.productDetailForm, goodsSkusKey, active_sku[goodsSkusKey])
                }
                this.productDetailForm.goods_sku_name = active_sku.goods_name
                this.productDetailForm.goods_name = this.productDetail.goods_name
                if (this.productDetailForm.is_sale === 1) {
                    this.productDetailForm.type = 1
                    this.productDetailForm.guide_price = this.productDetailForm.sale_price
                    this.productDetailForm.sale_guide_price = this.productDetailForm.sale_price
                    this.productDetailForm.price.value = this.productDetailForm.sale_price
                    this.productDetailForm.price.text = this.productDetailForm.sale_price
                    this.productDetailForm.price.value_converted = this.productDetailForm.price.value
                    const subtotal_price = this.productDetailForm.price.value * this.productDetailForm.num
                    this.productDetailForm.subtotal_price.value = Number(subtotal_price.toFixed(2))
                    this.productDetailForm.subtotal_price.text = this.productDetailForm.subtotal_price.value.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })
                    this.productDetailForm.subtotal_price.value_converted = this.productDetailForm.subtotal_price.value
                } else {
                    if (this.productDetailForm.is_lease === 1) {
                        this.productDetailForm.type = 2
                        this.productDetailForm.guide_price = this.productDetailForm.lease_price
                        this.productDetailForm.lease_guide_price = this.productDetailForm.lease_price
                    }
                }
            }
        },

        //点击选择组合产品的部位下的配置
        handleClickOtherGoodsPartItem(goods_part, item) {
            this.$set(goods_part, 'active_sku_id', item.goods_part_item_id)
            goods_part.active_sku = item.goods_skus[0]
            goods_part.unit = item.unit
            this.computedBundleGoodsPrice()
        },

        //点击选择组合产品的部位下的标准产品的配置
        handleClickBasicGoodsPartItem(goods_part, part_item, spec, item) {
            if (spec.active_sku_id === item.product_spec_value_id) return false
            if (item.disabled) return false
            this.$set(spec, 'active_sku_id', item.product_spec_value_id)
            goods_part.unit = part_item.unit
            let arr = [];
            if (part_item.goods_skus.length > 0) {
                const activeSkuId = Number(spec.active_sku_id);
                arr = this.getProductConfig(part_item.goods_skus, activeSkuId)
            }
            part_item.goods_specs.forEach(spec_item => {
                spec_item.goods_spec_values.forEach(spec_value => {
                    this.$set(spec_value, 'disabled', false)
                    if (arr.indexOf(spec_value.product_spec_value_id) < 0 && spec_value.product_spec_id !== spec.product_spec_id) {
                        this.$set(spec_value, 'disabled', true)
                        if (spec_value.product_spec_value_id === spec_item.active_sku_id) {
                            this.$set(spec_item, 'active_sku_id', 0)
                        }
                    }
                })
            })
            //如果每个配置下的配置项都选中了
            if (part_item.goods_specs.every(item => item.hasOwnProperty('active_sku_id') && item.active_sku_id > 0)) {
                const active_sku_ids = part_item.goods_specs.map(goods_spec => goods_spec.active_sku_id).sort((a, b) => a - b).join()
                goods_part.active_sku = part_item.goods_skus.find(sku => sku.sku_key === active_sku_ids)
                goods_part.active_sku_id = goods_part.active_sku.sku_id
            }
            this.computedBundleGoodsPrice()
        },

        //获取行业标准产品的配置组合
        getProductConfig(goods_skus, activeSkuId) {
            const arr = [];
            goods_skus.forEach(sku => {
                if (sku && sku.sku_key && typeof sku.sku_key === 'string') {
                    const skuKeys = new Set(sku.sku_key.split(',').map(item => {
                        const num = Number(item.trim());
                        return !isNaN(num) ? num : null;
                    }).filter(item => item !== null));
                    if (skuKeys.has(activeSkuId)) {
                        arr.push(...skuKeys);
                    }
                }
            });
            return [...new Set(arr)];
        },

        //组合产品部位下的数量变化
        handleGoodsPartNumChange() {
            this.computedBundleGoodsPrice()
        },

        //计算组合产品的金额信息
        computedBundleGoodsPrice() {
            if (this.productDetail.goods_parts.every(item => item.hasOwnProperty('active_sku_id') && item.active_sku_id > 0)) {
                this.productDetailForm.can_in_out_stock = this.productDetail.goods_parts.some(goods_part => goods_part.active_sku && goods_part.active_sku.can_in_out_stock === 1) ? 1 : 0
                if (this.productDetailForm.can_in_out_stock === 0) {
                    this.productDetailForm.start_at = null
                    this.productDetailForm.end_at = null
                }
                const cost_price = this.productDetail.goods_parts.reduce((total, item) => {
                    return total + (Number(item.active_sku.cost_price) * item.num)
                }, 0)
                const sale_guide_price = this.productDetail.goods_parts.reduce((total, item) => {
                    return total + (Number(item.active_sku.sale_price) * item.num)
                }, 0)
                const lease_guide_price = this.productDetail.goods_parts.reduce((total, item) => {
                    return total + (Number(item.active_sku.lease_price) * item.num)
                }, 0)
                this.productDetailForm.cost_price = cost_price.toFixed(2)
                this.productDetailForm.guide_price = this.productDetailForm.type === 1 ? sale_guide_price.toFixed(2) : lease_guide_price.toFixed(2)
                this.productDetailForm.sale_guide_price = sale_guide_price.toFixed(2)
                this.productDetailForm.lease_guide_price = lease_guide_price.toFixed(2)
                this.productDetailForm.price.value = this.productDetailForm.guide_price
                this.productDetailForm.price.text = this.productDetailForm.guide_price.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
                this.productDetailForm.price.value_converted = this.productDetailForm.price.value
                const subtotal_price = this.productDetailForm.price.value * this.productDetailForm.num
                this.productDetailForm.subtotal_price.value = Number(subtotal_price.toFixed(2))
                this.productDetailForm.subtotal_price.text = this.productDetailForm.subtotal_price.value.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
                this.productDetailForm.subtotal_price.value_converted = this.productDetailForm.subtotal_price.value
            }
        },

        //点击添加组合产品的其他部位
        handleClickAddOtherConfig(item, index) {
            this.productDetail.goods_parts.push(JSON.parse(JSON.stringify(item)))
            if (item.is_add === 0) {
                this.bundleGoodsOtherConfig.splice(index, 1)
            }
            this.otherConfigVisible = false
        },

        //点击删除部位
        handleClickDeleteGoodsPart(goods_part, index) {
            if (this.productDetail.goods_parts.length === 1) return this.$toast.fail('至少添加一个部位')
            this.productDetail.goods_parts.splice(index, 1)
            if (goods_part.is_add === 0 && this.productDetail.goods_parts.findIndex(part => part.goods_part_id === goods_part.goods_part_id) < 0 && this.bundleGoodsOtherConfig.findIndex(item => item.goods_part_id === goods_part.goods_part_id) < 0) {
                goods_part.active_sku = {}
                goods_part.active_sku_id = 0
                this.bundleGoodsOtherConfig.push(goods_part)
            }
            this.computedBundleGoodsPrice()
        },

        //租借产品选择租借时间事件
        handleStartEndAtChange(val) {

        },

        //选择产品配置取消事件
        handleClickProductConfigCancel() {
            this.$emit('update:dialogVisible', false)
        },

        //选择产品配置确定事件
        handleClickProductConfigSubmit(close) {
            if (this.source === 'order') {
                this.$refs.productDetailForm.validate().then(() => {
                    this.submitProductConfigForm(close)
                }).catch((error) => {
                    if (error.length) {
                        this.$toast.fail(error[0].message)
                    }
                })
            } else {
                this.submitProductConfigForm(close)
            }
        },

        submitProductConfigForm(close) {
            let data = {}
            if (this.product_type === 'bundle') {
                if (this.productDetail.goods_parts.some(item => !item.active_sku)) return this.$toast.fail('请选择所有产品的规格或将产品删除')
                data = {
                    type: this.productDetailForm.type,
                    goods_id: this.productDetail.goods_id,
                    order_goods_id: this.productDetailForm.order_goods_id,
                    goods_name: this.productDetail.goods_name,
                    goods_type: this.productDetail.goods_type,
                    goods_sku_id: 0,
                    sku_key: '',
                    goods_sku_name: this.productDetail.goods_name,
                    start_at: this.productDetailForm.start_at || null,
                    end_at: this.productDetailForm.end_at || null,
                    cost_price: this.productDetailForm.cost_price,
                    guide_price: this.productDetailForm.guide_price,
                    sale_guide_price: this.productDetailForm.sale_guide_price,
                    lease_guide_price: this.productDetailForm.lease_guide_price,
                    price: this.productDetailForm.price,
                    num: this.productDetailForm.num,
                    subtotal_price: this.productDetailForm.subtotal_price,
                    unit: this.productDetail.unit,
                    is_virtual: this.productDetailForm.can_in_out_stock,
                    goods_image: this.productDetail.image && this.productDetail.image.length ? this.productDetail.image[0] : ['https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'],
                    is_sale: this.productDetail.is_sale,
                    is_lease: this.productDetail.is_lease,
                    description: this.productDetail.description,
                    category_id: this.productDetail.category_id,
                }
                data._child = this.productDetail.goods_parts.map(goods_part => {
                    return {
                        type: this.productDetailForm.type,
                        goods_id: goods_part.goods_id,
                        order_goods_id: goods_part.order_goods_id,
                        goods_name: goods_part.part_name,
                        goods_type: goods_part.type,
                        goods_sku_id: goods_part.active_sku.goods_sku_id,
                        sku_key: goods_part.active_sku.sku_key,
                        goods_sku_name: goods_part.active_sku.goods_name,
                        part_id: goods_part.goods_part_id,
                        part_name: goods_part.part_name,
                        start_at: this.productDetailForm.start_at || null,
                        end_at: this.productDetailForm.end_at || null,
                        cost_price: goods_part.active_sku.cost_price,
                        guide_price: this.productDetailForm.type === 1 ? goods_part.active_sku.sale_price : goods_part.active_sku.lease_price,
                        num: goods_part.num,
                        price: {
                            value: 0,
                            text: 0,
                            currency: 'CNY',
                            value_converted: 0
                        },
                        subtotal_price: {
                            value: 0,
                            text: 0,
                            currency: 'CNY',
                            value_converted: 0
                        },
                        unit: goods_part.unit,
                        is_virtual: goods_part.active_sku.can_in_out_stock
                    }
                })
                this.$emit('submit', {
                    data,
                    close
                })
            } else {
                if (this.productDetail.goods_specs.some(item => !item.active_sku_id)) return this.$toast.fail('请选择产品规格')
                data = {
                    type: this.productDetailForm.type,
                    goods_id: this.productDetail.goods_id,
                    order_goods_id: this.productDetailForm.order_goods_id,
                    goods_name: this.productDetail.goods_name,
                    goods_type: this.productDetailForm.goods_type,
                    goods_sku_id: this.productDetailForm.goods_sku_id,
                    sku_key: this.productDetailForm.sku_key,
                    goods_sku_name: this.productDetailForm.goods_sku_name,
                    start_at: this.productDetailForm.start_at || null,
                    end_at: this.productDetailForm.end_at || null,
                    cost_price: this.productDetailForm.cost_price,
                    guide_price: this.productDetailForm.guide_price,
                    lease_guide_price: this.productDetailForm.lease_guide_price,
                    sale_guide_price: this.productDetailForm.sale_guide_price,
                    price: this.productDetailForm.price,
                    num: this.productDetailForm.num,
                    subtotal_price: this.productDetailForm.subtotal_price,
                    unit: this.productDetail.unit,
                    is_virtual: this.productDetailForm.can_in_out_stock,
                    goods_image: this.productDetail.image && this.productDetail.image.length ? this.productDetail.image[0] : ['https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'],
                    is_sale: this.productDetailForm.is_sale,
                    is_lease: this.productDetailForm.is_lease,
                    description: this.productDetail.description,
                    category_id: this.productDetail.category_id,
                }
                this.$emit('submit', {
                    data,
                    close
                })
            }
            this.handleClickProductConfigCancel()
        },
    },
}
</script>
<style lang="scss" scope>
.product_detail_wrap {
    display: flex;
    flex-direction: column;
    padding: 0 16px;

    .product_image_wrap {
        display: flex;
        align-items: start;
        gap: 8px;

        .el-carousel__container {
            width: 72px;
            height: 72px;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
        }

        .goods_name {
            font-weight: 700;
            line-height: 24px;
            color: #333333;
        }
    }

    .goods_description_wrap {
        line-height: 22px;
        color: #666666;
        margin-top: 8px;
    }

    .product_config_wrap {
        flex: 1;
        overflow-y: auto;
        margin-top: 16px;
        max-height: 60vh;

        .goods_parts_list {
            .goods_parts_item {
                margin-bottom: 12px;

                .part_name_wrap {
                    font-weight: 700;
                    line-height: 22px;
                    color: #333333;
                    margin-bottom: 4px;
                }

                .goods_spec_wrap {
                    padding: 8px;
                    border: 2px solid #EDF0F4;
                    border-radius: 6px;

                    .goods_spec_item {
                        margin-bottom: 0;

                        .part_spec_item {
                            margin-bottom: 16px;

                            &:last-child {
                                margin-bottom: 0;
                            }

                            .spec_name {
                                color: #999999;
                                line-height: 22px;
                                margin-bottom: 8px;
                            }
                        }
                    }
                }

                .part_num_wrap {
                    padding: 8px 0;
                    border-bottom: 1px solid #E8E8E8;
                }
            }
        }

        .add_other_config_btn {
            text-align: center;
            padding: 5px 0;
            color: #2990FF;
            cursor: pointer;
            border: 1px dashed #2990FF;
            border-radius: 4px;
            margin-bottom: 24px;
        }

        .goods_spec_list {
            .goods_spec_item {
                margin-bottom: 16px;

                .goods_spec_name {
                    line-height: 22px;
                    color: #999999;
                    margin-bottom: 8px;
                }
            }
        }

        .goods_spec_values {
            display: flex;
            gap: 8px;
            flex-wrap: wrap;
            align-items: center;

            .goods_spec_value {
                padding: 0 8px;
                line-height: 22px;
                color: #666666;
                border-radius: 4px;
                border: 1px solid #D9D9D9;
                cursor: pointer;

                &:hover {
                    color: #333333;
                    border-color: #2990FF;
                }

                &.active {
                    color: #2990FF;
                    border-color: #2990FF;
                    background-color: rgba(25, 144, 255, 0.16);
                }

                &.is_disabled {
                    color: #999999;
                    border-color: #D9D9D9;
                    cursor: not-allowed;
                    background: #F7F7F7;
                }
            }
        }

        .van-cell {
            padding: 10px 0;
        }
    }
}

.product_config_btn_wrap {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;

    .el-button {
        flex: 1;
    }
}

.other_config_wrap {
    width: 100%;
    height: 100%;
    padding: 0 16px 35px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .other_config_list {
        max-height: calc(100% - 90px);
        overflow-y: auto;

        .other_config_item {
            background-color: #FFFFFF;
            text-align: center;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            padding: 10px 0;
            color: #666666;
            border-bottom: 1px solid #DEDEDE;

            &:first-child {
                border-radius: 8px 8px 0 0;
            }

            &:last-child {
                border-bottom: none;
                border-radius: 0 0 8px 8px;
            }
        }
    }

    .cancel_btn {
        background-color: #FFFFFF;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        padding: 10px 0;
        color: #666666;
        border-radius: 8px;
        box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
        margin-top: 10px;
    }
}
</style>